import React from 'react';
import { Link } from 'react-router-dom';
interface NewsCardProps {
  title: string;
  excerpt: string;
  imageUrl: string;
  author: string;
  date: string;
  category?: string;
  isLarge?: boolean;
  id?: number;
}
export const NewsCard = ({
  title,
  excerpt,
  imageUrl,
  author,
  date,
  category,
  isLarge = false,
  id = 0
}: NewsCardProps) => {
  return <Link to={`/article/${id}`} data-id="element-182">
      <article className={`bg-white rounded-lg overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-shadow ${isLarge ? 'flex flex-col md:flex-row' : ''}`} data-id="element-183">
        <div className={`${isLarge ? 'md:w-2/5' : 'w-full'}`} data-id="element-184">
          <img src={imageUrl} alt={title} className={`w-full h-48 object-cover ${isLarge ? 'md:h-full' : ''}`} data-id="element-185" />
        </div>
        <div className={`p-4 ${isLarge ? 'md:w-3/5' : ''}`} data-id="element-186">
          {category && <span className="inline-block bg-blue-100 text-blue-800 px-2 py-1 text-xs font-medium rounded mb-2" data-id="element-187">
              {category.toUpperCase()}
            </span>}
          <h3 className={`font-bold text-gray-900 mb-2 ${isLarge ? 'text-xl' : 'text-lg'} hover:text-blue-600 transition-colors`} data-id="element-188">
            {title}
          </h3>
          <p className="text-gray-600 text-sm mb-4 line-clamp-2" data-id="element-189">{excerpt}</p>
          <div className="flex items-center text-gray-500 text-xs" data-id="element-190">
            <span className="mr-3" data-id="element-191">{author}</span>
            <span data-id="element-192">{date}</span>
          </div>
        </div>
      </article>
    </Link>;
};